import React, { useState, useEffect } from 'react';
import Footer from './Footer';
import Employees from './Employees';
import About from './About';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

import Vendor from './Vendor/Vendor';
import MyTime from './MyTime/MyTime';
import Timesheet from './admin/AdminTimesheet/Timesheet';
import Customer from './CustomerNew/Customer';
import Setup from './Setup/Setup';
import ApproveTimesheet from './admin/ApproveTimesheet/ApproveTimesheet';
import SideNav from './SideNav/SideNav';
import User from './UserNew/User';
import MyExpense from './MyExpense/MyExpense';
import Expense from './admin/AdminExpense/Expense';
import Item from './Item/Item';
import Class from './Class/Class';
import QboEmployee from './QboEmployee/QboEmployee';
import MyQualification from './MyQualification/MyQualification';
import MyProfileNew from './MyProfile/MyProfileNew';
import Asset from './Asset/Asset';
import MyAsset from './MyAsset/MyAsset';
import NotificationList from './Notification/NotificationList/NotificationList';
import AdminQualification from './admin/AdminQualification/AdminQualification';
import AdminRequestLeave from './admin/AdminRequestLeave/AdminRequestLeave';
import VehicleTracker from './VehicleTracker/VehicleTracker';
import MyAssetMap from './MyAssetMap/MyAssetMap';
import Beacon from './Beacon/Beacon';
import Tracker from './Tracker/Tracker';
import TimesheetBillLogs from './admin/TimesheetBillLogs/TimesheetBillLogs';
import Qualification from './Qualification/Qualification';
import TimesheetSchedule from './TimesheetSchedule/TimesheetSchedule';
import MyTask from './MyTask/MyTask';
import TotalTask from './admin/TotalTask/TotalTask';
import CustomerSmsInbox from './CustomerSmsInbox/CustomerSmsInbox';
import WhatsappMessageInbox from './WhatsappMessageInbox/WhatsappMessageInbox';
import Invoices from './Invoices/Invoices';
import Purchase from './purchase/Purchase';

function cn(...inputs) {
  return twMerge(clsx(inputs));
}

function Home() {
  // eslint-disable-next-line no-undef
  const [matches, setMatches] = useState(window.matchMedia('(min-width: 600px)').matches);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line no-undef
    const media = window.matchMedia('(min-width: 600px)');

    const listener = (e) => setMatches(e.matches);

    media.addEventListener('change', listener);

    return () => {
      media.removeEventListener('change', listener);
    };
  }, []);

  const handleDrawerToggle = () => {
    if (matches) {
      setIsCollapsed(!isCollapsed);
    } else {
      setMobileOpen(!mobileOpen);
    }
  };

  const handleAppTitle = () => {
    // eslint-disable-next-line no-undef
    window.location.href = '/';
  };

  return (
    <Router>
      <div className="tw-min-h-screen tw-bg-gray-50">
        <SideNav
          isCollapsed={isCollapsed}
          mobileOpen={mobileOpen}
          handleDrawerToggle={handleDrawerToggle}
          handleAppTitle={handleAppTitle}
        />

        <main
          className={cn(
            'tw-pt-24 tw-transition-all tw-duration-300',
            matches ? (isCollapsed ? 'tw-ml-20 tw-p-8' : 'tw-ml-64 tw-p-8') : 'tw-p-4'
          )}
        >
          <div className="tw-w-7xl tw-mx-auto">
            <Switch>
              <Route path="/" exact component={TimesheetSchedule} />
              <Route path="/timesheetSchedule" component={TimesheetSchedule} />
              <Route path="/employees" component={Employees} />
              <Route path="/users" component={User} />
              <Route path="/about" component={About} />
              <Route path="/mytime" component={MyTime} />
              <Route path="/myexpenses" component={MyExpense} />
              <Route path="/customers" component={Customer} />
              <Route path="/expenses" component={Expense} />
              <Route path="/invoices" component={Invoices} />
              <Route path="/timesheets" component={Timesheet} />
              <Route path="/billlogs" component={TimesheetBillLogs} />
              <Route path="/approvetimesheets" component={ApproveTimesheet} />
              <Route path="/suppliers" component={Vendor} />
              <Route path="/item" component={Item} />
              <Route path="/setup" component={Setup} />
              <Route path="/asset" component={Asset} />
              <Route path="/myasset" component={MyAsset} />
              <Route path="/myprofile" component={MyProfileNew} />
              <Route path="/myqualification" component={MyQualification} />
              <Route path="/class" component={Class} />
              <Route path="/qboEmployee" component={QboEmployee} />
              <Route path="/qualification/:employeeId" component={AdminQualification} />
              <Route path="/notification" component={NotificationList} />
              <Route path="/maps" component={VehicleTracker} />
              <Route path="/myassetmaps" component={MyAssetMap} />
              <Route path="/qualifications" component={Qualification} />
              <Route path="/requestLeave/:employeeId" component={AdminRequestLeave} />
              <Route path="/beacon" component={Beacon} />
              <Route path="/tracker" component={Tracker} />
              <Route path="/myTask" component={MyTask} />
              <Route path="/totalTask" component={TotalTask} />
              <Route path="/textMessage" component={CustomerSmsInbox} />
              <Route path="/whatsapp" component={WhatsappMessageInbox} />
              <Route path="/purchase" component={Purchase} />
            </Switch>
          </div>
        </main>
      </div>

      <Footer />
    </Router>
  );
}

export default Home;
